<template>
    <div>
        <Slider></Slider>
        <Body></Body>
        <Form></Form>
    </div>
</template>

<script>
import Slider from './Slider';
import Body from './Body';
import Form from './Form';

export default {
    name: "CustomQuote",
    components: {
      Slider,
      Body,
      Form
    },
    created() {
      let jqueryScript = document.createElement('script')
      jqueryScript.setAttribute('src', '/jquery.min.js')
      document.head.appendChild(jqueryScript)

      let bootstrapScript = document.createElement('script')
      bootstrapScript.setAttribute('src', '/bootstrap.bundle.min.js')
      document.head.appendChild(bootstrapScript)
    }
}
</script>